import React from 'react';
import { motion } from 'framer-motion';
export function PestGallery() {
  return <section className="bg-mobal-black py-20" data-id="element-243">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12 max-w-3xl mx-auto" data-id="element-245">
          <h2 className="text-3xl md:text-5xl font-heading font-black text-mobal-white mb-4 leading-tight" data-id="element-246">
            Si ves una, hay cientos.
          </h2>
          <p className="text-2xl md:text-3xl font-heading font-black text-mobal-green" data-id="element-247">
            El problema ya está adentro.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-5xl mx-auto" data-id="element-248">
          <img src="https://cdn.magicpatterns.com/uploads/aiPqJv6bA97ePws4PbHzBi/imagen_insectos.jpg" alt="Tipos de plagas: cucarachas, ratas, hormigas, alacranes, arañas, ácaros y chinches" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-249" />
        </motion.div>
      </div>
    </section>;
}